export const BINARY = 1
export const CATEGORY = 2
export const CHECKBOXES = 3
export const MULTIPLE_CHOICE = 4
export const TEXT_FIELD = 5